import * as React from 'react'
import classNames from 'classnames'
import { Stack, Typography, Grid2 } from '@mui/material'
import { formatWeightAsGrams } from 'utils/formatWeightAsGrams'

/** hooks */
import { ProductPerformance } from 'api/inventory'

/** utils */
import { formattedPrice } from 'utils/util'

/** styles */
import useStyles from './styles'

type Props = {
  data?: ProductPerformance
  currentValue: string
}

export default function GridValue(props: Props) {
  const { data, currentValue } = props
  const { classes } = useStyles()

  const totalReturn = Number(data?.totalReturn || 0).toFixed(2)
  const totalCost = Number(data?.totalCost || 0).toFixed(2)
  const totalReturnAsPercentage = formattedPrice(
    data?.totalReturnAsPercentage || 0
  )
  const quantityOwned = data?.quantityOwned || 0
  const periodInvestedInDays = data?.periodInvestedInDays || 0

  const getTime = () => {
    switch (true) {
      case periodInvestedInDays < 30:
        return `${periodInvestedInDays} day`
      case periodInvestedInDays < 365:
        return `${Math.floor(periodInvestedInDays / 30)} month`
      default:
        const year = Math.floor(periodInvestedInDays / 365)
        const month = Math.floor((periodInvestedInDays - year * 365) / 30)
        return `${year} year, ${month} month`
    }
  }

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem1)}
        >
          <Typography>CURRENT VALUE:</Typography>
          <Typography>${currentValue}</Typography>
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem2)}
        >
          <Typography>PERCENTAGE RETURN:</Typography>
          <Typography>{totalReturnAsPercentage}%</Typography>
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem2)}
        >
          <Typography>TOTAL RETURN:</Typography>
          <Typography>
            {isNaN(Number(totalReturn)) ? 0 : totalReturn}
          </Typography>
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem1)}
        >
          <Typography>QUANTITY OWNED:</Typography>
          <Typography>
            {formatWeightAsGrams(Number(quantityOwned ?? 0))}
          </Typography>
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem1)}
        >
          <Typography>AMOUNT INVESTED:</Typography>
          <Typography>${isNaN(Number(totalCost)) ? 0 : totalCost}</Typography>
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Stack
          className={classNames(classes.gridValueItem, classes.gridValueItem1)}
        >
          <Typography>PERIOD INVESTED:</Typography>
          <Typography>{getTime()}</Typography>
        </Stack>
      </Grid2>
    </Grid2>
  )
}
